/** @format */

import { useMutation } from "@tanstack/react-query";
import service from "../service/service";

const useSaveAdLinks = () =>
  useMutation({
    mutationKey: ["adLinks"],
    mutationFn: adLinksData => {
      let api__data  = {
        reportDate: adLinksData.reportDate,
        regionId: adLinksData.regionId,
        productLineId: adLinksData.productLineId,
        imagePath: adLinksData.imagePath,
        redirectURL: adLinksData.redirectUrl,
        title: adLinksData.title,
        id: adLinksData.id
      }
      return service.saveAdLinks(api__data)
    },
  });

export default useSaveAdLinks;
